import { render, staticRenderFns } from "./TileDataContentRowTwoColumn.vue?vue&type=template&id=3b73c397"
import script from "./TileDataContentRowTwoColumn.vue?vue&type=script&lang=js"
export * from "./TileDataContentRowTwoColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports